const spinner = {
  baseStyle: {
    color: 'primary.500',
  },
  sizes: {},
  variants: {},
  defaultProps: {},
}

export default spinner
